import React from 'react';
import * as S from './PayAtHotelPersuasion.styles';

// ICONS
import PayAtHotelIcon from '../../../../../../stories/Icons/PayAtHotel';
import PayAtHotelCCIcon from '../../../../../../stories/Icons/PayAtHotelCC';
import ReserverNowPayLaterIcon from '../../../../../../stories/Icons/ReserveNowPayLater';

const PayModePersuasionInfo: React.FC<{paymode: number; price: number; tax: number}> = ({
  paymode,
  price,
  tax,
}) => {
  if (!paymode) return null;

  return (
    // <S.PayModePersuasionContainer>
    <>
      {(paymode === 2 || paymode === 4) && (
        <>
          <li>+ {tax} taxes & fees @ hotel</li>
          {/* <PayAtHotelIcon />
          <S.PayModePersuasionTextsContainer>
            <S.PayModePersuasionTextContainer>
              Pay ₹ {price} / night
            </S.PayModePersuasionTextContainer>
            <S.TaxesTextStyled>
              <S.PayAtHotelTaxesText>+ {tax} taxes & fees</S.PayAtHotelTaxesText>
              <S.PayModePersuasionTextContainer>
                <b> @ hotel</b>
              </S.PayModePersuasionTextContainer>
            </S.TaxesTextStyled>
          </S.PayModePersuasionTextsContainer> */}
        </>
      )}

      {paymode === 3 && (
        <>
          <li>
            <S.PayModePersuasionTextContainer>Pay@Hotel </S.PayModePersuasionTextContainer>
            <S.PayModePersuasionSubTextContainer>(Credit card details required)</S.PayModePersuasionSubTextContainer>
          </li>
          {/* <PayAtHotelCCIcon />
          <S.PayModePersuasionTextsContainer>
            <S.PayModePersuasionTextContainer>Pay@Hotel</S.PayModePersuasionTextContainer>
            <S.PayModePersuasionTextContainer>
              Credit card details required
            </S.PayModePersuasionTextContainer>
          </S.PayModePersuasionTextsContainer> */}
        </>
      )}

      {paymode === 5 && (
        <li>Reserve now ₹0, pay later</li>
        // <S.PayModePersuasionTextContainer>
        //   <ReserverNowPayLaterIcon />
        //   <S.PayModePersuasionTextContainer>
        //     Reserve now ₹0, pay later
        //   </S.PayModePersuasionTextContainer>
        // </S.PayModePersuasionTextContainer>
      )}
      {/* </S.PayModePersuasionContainer> */}
    </>
  );
};

export default PayModePersuasionInfo;
